"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UploadField = _interopRequireDefault(require("./../Buttons/UploadField"));

var _FileBox = _interopRequireDefault(require("./FileBox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-left: 3vw;\n  span {\n    font-size: 15px;\n  }\n  .fileName {\n    font-weight: 900;\n    margin-right: 1vw;\n    max-width: 10vw;\n  }\n\n  .fileSize {\n    color: #76726e;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media (max-width: 780px) {\n    flex-direction: column;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var removeFile = function removeFile(dt, id) {
  return dt.items.remove(id);
};

var updateFiles = function updateFiles(dt, id, fileList) {
  var isRemoving = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  isRemoving && removeFile(dt, id);

  for (var j = 0; j < fileList.length; j++) {
    dt.items.add(fileList[j]);
  }

  return dt;
};

var bytesToMega = function bytesToMega(value) {
  var val = value > 10000 ? "".concat((value / 1000000).toFixed(2), " mb") : "".concat((value / 1000).toFixed(2), " kb");
  return val;
}; // Make text shorter if it's longer than 20 chars.


var shortifyText = function shortifyText(text) {
  if (text.length < 20) return text;else return "".concat(text.substring(0, 17), "...");
};

var Container = _styledComponents.default.div(_templateObject());

var Uploader = (0, _react.forwardRef)(function (_ref, ref) {
  var supported = _ref.supported,
      className = _ref.className,
      name = _ref.name,
      icon = _ref.icon,
      label = _ref.label,
      multiple = _ref.multiple,
      onClick = _ref.onClick,
      onClose = _ref.onClose,
      errorText = _ref.errorText,
      children = _ref.children;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      id = _useState2[0],
      setId = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      files = _useState6[0],
      setFiles = _useState6[1];

  var _useState7 = (0, _react.useState)(new DataTransfer()),
      _useState8 = _slicedToArray(_useState7, 2),
      dt = _useState8[0],
      setDT = _useState8[1];

  (0, _react.useEffect)(function () {
    setDT(function (v) {
      return updateFiles(v, id, [], true);
    });
  }, [id]);

  var readFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file, index) {
      var reader, parts, extension, fileNew;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reader = new FileReader();
              setLoaded(function (l) {
                return [].concat(_toConsumableArray(l), [0]);
              });
              parts = file.name.split('.');
              extension = parts.length > 1 ? parts.slice(-1)[0] : ''; // get last el. of parts arr

              fileNew = {
                title: parts[0],
                name: "".concat(shortifyText(parts[0])).concat(extension ? ".".concat(extension) : ''),
                size: bytesToMega(file.size),
                type: file.type,
                data: ''
              };
              _context.next = 7;
              return new Promise(function (resolve, reject) {
                reader.readAsDataURL(file);
                reader.addEventListener('progress', function (e) {
                  var percentage = file.size / e.loaded * 100;
                  setLoaded(function (l) {
                    l[index] = percentage;
                    return _toConsumableArray(l);
                  });
                });

                reader.onerror = function () {
                  reader.abort();
                  reject(new DOMException('Problem parsing input file.'));
                };

                reader.addEventListener('loadend', function (e) {
                  fileNew.data = e.target.result;
                  setFiles(function (f) {
                    return [].concat(_toConsumableArray(f), [_extends({}, fileNew)]);
                  });
                  setLoaded(function (l) {
                    l[index] = null;
                    return _toConsumableArray(l);
                  });
                  resolve(fileNew);
                });
              });

            case 7:
              return _context.abrupt("return", _context.sent);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function readFile(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(uploaded) {
      var uploadedFiles;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (uploaded) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", false);

            case 2:
              // [...target.files].reduce(async (promise, file, i) => {
              //   await promise;
              //   await readFile(file, i);
              // }, Promise.resolve());
              if (!multiple) setFiles([]);
              setDT(function (dataTransfer) {
                var vdata = multiple ? dataTransfer : new DataTransfer();
                return updateFiles(vdata, -1, uploaded);
              });
              _context3.next = 6;
              return Promise.all(Array.from(uploaded).map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t, i) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return readFile(t, i);

                        case 2:
                          return _context2.abrupt("return", _context2.sent);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x4, _x5) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 6:
              uploadedFiles = _context3.sent;
              onClick({
                name: name,
                value: uploadedFiles
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleClick(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose(file) {
    var id;
    setFiles(function (f) {
      id = f.findIndex(function (fi) {
        return fi.name === file.name;
      });
      var newFiles = f.filter(function (file) {
        return file.name !== f[id].name;
      });
      setId(id);
      return _toConsumableArray(newFiles);
    });
    onClose();
  }; // if (ref.current && dt.files) ref.current.files = dt.files;


  return _react.default.createElement(StyledUploader, {
    className: className
  }, _react.default.createElement(_UploadField.default, {
    ref: ref,
    name: name,
    supported: supported,
    icon: icon,
    multiple: multiple,
    onClick: handleClick,
    label: label,
    errorText: errorText
  }), _react.default.createElement(Container, null, files.length ? children({
    files: files,
    loaded: loaded,
    handleClose: handleClose
  }) : null));
});

var StyledUploader = _styledComponents.default.div(_templateObject2());

Uploader.displayName = 'Uploader';
Uploader.defaultProps = {
  onClick: Function.prototype,
  onClose: Function.prototype
};
Uploader.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  name: _propTypes.string,
  icon: _propTypes.element,
  multiple: _propTypes.bool,
  onClick: _propTypes.func,
  onClose: _propTypes.func,
  errorText: _propTypes.string,
  supported: (0, _propTypes.arrayOf)({
    type: _propTypes.string,
    extension: _propTypes.string
  }),
  label: _propTypes.string
};
Uploader.FileBox = _FileBox.default;
var _default = Uploader;
exports.default = _default;